<kendo-expansionpanel [title]="'Customer Team'"
                      [subtitle]=""
                      [expanded]="true">
    <div class="row" *ngFor="let teamType of customerTeamTypeList;let idx = index;" style="padding-right:15px;">
        <div class="col fw-bold">
            {{teamType.description}}
        </div>
        <div class="col">
            <select name="employeeID{{idx}}"
                    class="form-select"
                    (change)="setEmployeeCustomerTeamMap(teamType.customerTeamTypeID, $event)"
                    *ngIf="teamType.employeeGroupID == null"
                    [disabled]="!isCRMAdmin && searchCustomer.customerStatus == 'Customer'">
                <option value="">-- Assign Employee --</option>
                <option *ngFor="let employee of getEmployeeListByGroupID(teamType.employeeGroupID)"
                        value="{{employee.employeeId}}"
                        [selected]="isEmployeeCustomerTeamType(teamType.customerTeamTypeID, employee.employeeId)">
                    {{employee.fullName}}
                </option>
            </select>
            <select name="employeeID{{idx}}"
                    class="form-select"
                    (change)="setEmployeeCustomerTeamMap(teamType.customerTeamTypeID, $event)"
                    *ngIf="teamType.employeeGroupID > 0"
                    [disabled]="!isCRMAdmin && searchCustomer.customerStatus == 'Customer'">
                <option value="">-- Assign Employee --</option>
                <option *ngFor="let employee of getEmployeeListByGroupID(teamType.employeeGroupID)"
                        value="{{employee.employeeID}}"
                        [selected]="isEmployeeCustomerTeamType(teamType.customerTeamTypeID, employee.employeeID)">
                    {{employee.firstName}} {{employee.lastName}}
                </option>
            </select>
        </div>
    </div>
</kendo-expansionpanel>
